import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) nav("/admin", { replace: true }); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail ? String(err.response.data.detail) : "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-brand-navy">
      <div className="hidden lg:block relative grain">
        <div className="absolute inset-0 grid place-items-center p-16">
          <div>
            <h1 className="font-serif text-5xl text-white leading-tight">WEDDING<br />EVENTS</h1>
            <p className="overline mt-4">Admin Console</p>
            <p className="mt-6 text-white/60 max-w-sm">Manage bookings, inquiries, gallery and testimonials in one place.</p>
          </div>
        </div>
      </div>
      <div className="grid place-items-center p-6">
        <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm bg-white p-8 rounded-sm">
          <div className="w-12 h-12 rounded-full bg-brand-navy grid place-items-center mb-6"><Lock className="text-brand-gold" size={20} /></div>
          <h2 className="font-serif text-2xl text-brand-navy">Admin Login</h2>
          <p className="text-sm text-brand-ink/60 mt-1">Sign in to manage your site.</p>
          <div className="mt-6 space-y-4">
            <div><Label className="text-xs uppercase tracking-widest text-brand-ink/60">Email</Label><Input required type="email" data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} /></div>
            <div><Label className="text-xs uppercase tracking-widest text-brand-ink/60">Password</Label><Input required type="password" data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)} /></div>
          </div>
          <button disabled={loading} data-testid="admin-login-submit" className="mt-6 w-full inline-flex justify-center items-center gap-2 bg-brand-navy text-white font-semibold py-3 rounded-sm hover:bg-brand-blue transition-colors disabled:opacity-60">
            {loading && <Loader2 size={18} className="animate-spin" />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
